// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Discover: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 50 30" enableBackground="new 0 0 50 30" xmlSpace="preserve">
<path d="M45.99,0C48.21,0,50,1.79,50,4v22c0,2.21-1.79,4-4.01,4l0.2,0c-0.06,0-0.13,0-0.2,0H4.01C1.79,30,0,28.21,0,26V4
	c0-2.21,1.79-4,4.01-4H45.99z M45.99,1H4.01c-1.6,0-2.91,1.25-3,2.82L1,4v22c0,1.6,1.25,2.9,2.83,2.99L4.01,29l13.41,0
	C34.93,25.37,45.79,19.41,49,17.48L49,4c0-1.6-1.25-2.9-2.83-2.99L45.99,1z M30.36,10.56l1.61,3.89l1.64-3.89h1.28l-2.62,5.94h-0.63
	l-2.57-5.94H30.36z M15.38,10.46c0.66,0,1.27,0.22,1.78,0.64l-0.61,0.77c-0.31-0.33-0.6-0.47-0.95-0.47c-0.51,0-0.88,0.28-0.88,0.64
	c0,0.31,0.21,0.48,0.92,0.73c1.34,0.47,1.74,0.89,1.74,1.81c0,1.12-0.86,1.9-2.09,1.9c-0.9,0-1.55-0.34-2.09-1.1l0.76-0.71
	c0.27,0.51,0.73,0.77,1.29,0.77c0.53,0,0.92-0.35,0.92-0.82c0-0.24-0.12-0.45-0.35-0.6c-0.12-0.07-0.35-0.18-0.82-0.33
	c-1.11-0.39-1.49-0.79-1.49-1.59C13.49,11.18,14.31,10.46,15.38,10.46L15.38,10.46z M26.08,10.45c1.74,0,3.16,1.35,3.16,3.02
	c0,1.67-1.41,3.02-3.16,3.02c-1.74,0-3.16-1.35-3.16-3.02C22.93,11.8,24.34,10.45,26.08,10.45z M20.96,10.43
	c0.51,0,0.94,0.1,1.45,0.35v1.33c-0.49-0.46-0.92-0.65-1.48-0.65c-1.11,0-1.98,0.88-1.98,1.99c0,1.17,0.84,2,2.03,2
	c0.54,0,0.95-0.18,1.43-0.63v1.33c-0.54,0.24-0.97,0.34-1.48,0.34c-1.8,0-3.2-1.32-3.2-3.02C17.74,11.78,19.17,10.43,20.96,10.43
	L20.96,10.43z M7.76,10.56c1.91,0,3.25,1.19,3.25,2.9c0,0.85-0.41,1.68-1.1,2.22c-0.58,0.46-1.24,0.67-2.16,0.67H6.03v-5.79H7.76z
	 M12.73,10.56v5.79h-1.18v-5.79H12.73z M38.77,10.56v0.98H36.6v1.29h2.08v0.98H36.6v1.56h2.17v0.98h-3.35v-5.79L38.77,10.56z
	 M41.3,10.56c1.36,0,2.14,0.62,2.14,1.71c0,0.89-0.49,1.47-1.38,1.64l1.9,2.44h-1.45l-1.63-2.33h-0.15v2.33h-1.18v-5.79L41.3,10.56z
	 M7.53,11.54H7.21v3.83h0.32c0.76,0,1.24-0.14,1.62-0.46c0.41-0.35,0.65-0.9,0.65-1.46c0-0.56-0.24-1.09-0.65-1.44
	C8.75,11.67,8.29,11.54,7.53,11.54L7.53,11.54z M41.1,11.47h-0.36v1.75h0.34c0.76,0,1.15-0.31,1.15-0.89
	C42.23,11.77,41.83,11.47,41.1,11.47L41.1,11.47z"/>
</svg>;
};

export default React.memo(Discover);
